(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mega-columns"] && !Shopify.designMode) return;
  try {
    class MegaColumns extends HTMLElement {
    connectedCallback() {
      this.preview = this.querySelector('[data-mega-preview]');
      if (!this.preview) return;
      this.links = Array.from(this.querySelectorAll('[data-mega-title]'));
      this.current = this.links.find((link) => link.classList.contains('is-active'));
      this.links.forEach((link) => {
        link.addEventListener('mouseenter', () => this.show(link));
        link.addEventListener('focus', () => this.show(link));
      });
      this.addEventListener('pointerenter', () => this.preload(), { once: true });
      this.addEventListener('focusin', () => this.preload(), { once: true });
      if (this.preview.hasAttribute('data-mega-empty')) {
        const first = this.links.find((link) => link.dataset.megaImage);
        if (first) this.show(first);
      }
    }

    preload() {
      this.links.forEach((link) => {
        if (!link.dataset.megaImage) return;
        const image = new Image();
        image.sizes = '300px';
        image.srcset = link.dataset.megaSrcset;
      });
    }

    show(link) {
      if (link === this.current) return;
      this.current = link;
      this.links.forEach((item) => item.classList.toggle('is-active', item === link));
      this.preview.href = link.href;
      this.preview.querySelector('[data-mega-preview-title]').textContent = link.dataset.megaTitle;
      this.preview.querySelector('[data-mega-preview-meta]').textContent = link.dataset.megaMeta;
      const media = this.preview.querySelector('[data-mega-preview-media]');
      let image = media.querySelector('img');
      if (!link.dataset.megaImage) {
        if (image) image.remove();
        return;
      }
      if (!image) {
        image = document.createElement('img');
        image.width = 300;
        image.height = 300;
        media.append(image);
      }
      image.classList.remove('is-swapping');
      void image.offsetWidth;
      image.classList.add('is-swapping');
      image.sizes = '300px';
      image.srcset = link.dataset.megaSrcset;
      image.src = link.dataset.megaImage;
      image.alt = link.dataset.megaAlt || '';
    }
  }

  if (!customElements.get('mega-columns')) customElements.define('mega-columns', MegaColumns);
  } catch(e) { console.error(e); }
})();

})();
